import { Component, Input, OnInit } from '@angular/core';
import { PrimeIcons } from 'primeng/api';

@Component({
  selector: 'app-cx-button-pdf',
  templateUrl: './cx-button-pdf.component.html',
  styleUrls: ['./cx-button-pdf.component.scss']
})
export class CxButtonPdfComponent implements OnInit {

  iconoPdf = PrimeIcons.FILE_PDF;

  @Input()
  isDisabled: boolean;

  @Input()
  isPrimaryButton: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
